import { render, staticRenderFns } from "./GroupInfo.vue?vue&type=template&id=86356eea&"
import script from "./GroupInfo.vue?vue&type=script&lang=ts&"
export * from "./GroupInfo.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports